<template>
  <div class="app-layout__page" :class="css">
    <div class="app-layout__container">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CenteredLayout',
  props: {
    white: {
      type: Boolean,
      default: false,
      required: false,
    },
    horizontal: {
      type: Boolean,
      default: false,
      required: false,
    },
    vertical: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  data() {
    return {
      css: {
        'app-layout__page--white': this.white,
        'app-layout__page--middle': this.horizontal,
        'app-layout__page--center': this.vertical,
      },
    };
  },
};
</script>
